import { useAppState, useAppDispatch } from '../../Shared/AppContext';

export function useHeaderState() {
  return useAppState();
}

export function useHeaderActions() {
  const dispatch = useAppDispatch();

  function initializeState() {
    dispatch((state) => ({
      ...state,
      header: {
        navExpanded: false,
        navigationMenuOpen: false,
        activeGroup: null,
      },
    }));
  }

  function toggleNav() {
    dispatch((state) => ({
      ...state,
      header: {
        ...state.header,
        navExpanded: !state.header.navExpanded,
      },
    }));
  }

  function openNavigationMenu(groupId = null) {
    dispatch((state) => ({
      ...state,
      header: {
        ...state.header,
        navigationMenuOpen: true,
        activeGroup: groupId,
        navExpanded: false, // Close mobile nav when opening modal
      },
    }));
  }

  function closeNavigationMenu() {
    dispatch((state) => ({
      ...state,
      header: {
        ...state.header,
        navigationMenuOpen: false,
        activeGroup: null,
      },
    }));
  }

  function openLoginWizard() {
    dispatch((state) => ({ ...state, loginWizardOpen: true }));
  }

  function closeLoginWizard() {
    dispatch((state) => ({ ...state, loginWizardOpen: false }));
  }

  function openInvitationRequestWizard() {
    dispatch((state) => ({ ...state, showInvitationRequestWizard: true }));
  }

  function onResponse(response) {
    dispatch((state) => ({ ...state, ...response }));
  }

  function onError(feedback) {
    dispatch((state) => ({ ...state, ...feedback }));
  }

  return {
    initializeState,
    toggleNav,
    openNavigationMenu,
    closeNavigationMenu,
    openLoginWizard,
    closeLoginWizard,
    openInvitationRequestWizard,
    onResponse,
    onError,
  };
}
